<template>
  <div class="text-xs-center">
    <v-pagination
      @input="$emit('changePage', pagination.page)" 
      v-model="pagination.page" 
      :length="pages">
    </v-pagination>
  </div>
</template>

<script>
export default {
  props: ['pagination', 'pages'],
  data() {
    return {

    }
  }
}  
</script>